(function () {
  const root = document.getElementById("uhwwt");
  if (!root) return;

  const loadedData = window.WHAT_WE_TEST_DATA || {};

  const defaults = {
    includedBadge: "Included in ENGNE test",
    testDetails: "Test details",
    areaTested: "Area tested",
    area: "Area",
    focusGroup: "Focus group",
    aboutListTitle: "Included tests",
    detailsListTitle: "Area and focus"
  };

  const uiLabels = Object.assign({}, defaults, ((loadedData.settings || {}).labels || {}));
  const meta = loadedData.meta || {};
  const sections = hydrateSections(loadedData.sections || []);
  const detailsMap = flattenContent(loadedData.content || {});

  const navEl = document.getElementById("uhwwtNav");
  const contentEl = document.getElementById("uhwwtContent");
  const noResultsEl = document.getElementById("uhwwtNoResults");
  const searchInput = document.getElementById("uhwwtSearch");
  const searchBtn = document.getElementById("uhwwtSearchBtn");
  const clearBtn = document.getElementById("uhwwtClear");
  const resultsEl = document.getElementById("uhwwtResults");
  const leftEl = root.querySelector(".uhwwt__left");
  const currentSlotEl = document.getElementById("uhwwtCurrentSlot");

  let currentAreaEl = null;
  let currentAreaSection = sections[0] || null;
  let navigationTargetId = "";
  let navigationReleaseTimer = 0;
  let stickySyncFrame = 0;

  const overlayEl = document.getElementById("uhwwtOverlay");
  const panelEl = document.getElementById("uhwwtPanel");
  const panelCloseEl = document.getElementById("uhwwtPanelClose");
  const panelEyebrowEl = document.getElementById("uhwwtPanelEyebrow");
  const panelTitleEl = document.getElementById("uhwwtPanelTitle");
  const panelSubtitleEl = document.getElementById("uhwwtPanelSubtitle");
  const panelBadgesEl = document.getElementById("uhwwtPanelBadges");
  const panelMetaEl = document.getElementById("uhwwtPanelMeta");
  const panelCopyEl = document.getElementById("uhwwtPanelCopy");
  const panelListTitleEl = document.getElementById("uhwwtPanelListTitle");
  const panelListEl = document.getElementById("uhwwtPanelList");
  const panelBlockEl = panelListEl ? panelListEl.closest(".uhwwt__panel-block") : null;

  if (!loadedData.sections || !loadedData.content) {
    if (noResultsEl) noResultsEl.hidden = true;
    if (contentEl) {
      contentEl.innerHTML = '<div class="uhwwt__no-results"><h3>Content failed to load</h3><p>Please upload what-we-test-data.js before what-we-test.js.</p></div>';
    }
    return;
  }

  const iconSvg = `
    <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path class="uhwwt__section-icon-frame" d="M22 3.5L37.6 12.5V31.5L22 40.5L6.4 31.5V12.5L22 3.5Z" stroke="currentColor" stroke-width="1.6"/>
      <path class="uhwwt__section-icon-lines" d="M16 14H29.5M16 22H27M16 30H30" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      <path class="uhwwt__section-icon-lines" d="M14 14V30" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
    </svg>
  `;

  const checkSvg = `
    <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M11 2.875C8.07031 2.875 5.41406 4.4375 3.92969 6.9375C2.48438 9.47656 2.48438 12.5625 3.92969 15.0625C5.41406 17.6016 8.07031 19.125 11 19.125C13.8906 19.125 16.5469 17.6016 18.0312 15.0625C19.4766 12.5625 19.4766 9.47656 18.0312 6.9375C16.5469 4.4375 13.8906 2.875 11 2.875ZM11 21C7.40625 21 4.125 19.125 2.32812 16C0.53125 12.9141 0.53125 9.125 2.32812 6C4.125 2.91406 7.40625 1 11 1C14.5547 1 17.8359 2.91406 19.6328 6C21.4297 9.125 21.4297 12.9141 19.6328 16C17.8359 19.125 14.5547 21 11 21ZM15.4141 9.16406L10.4141 14.1641C10.0234 14.5547 9.4375 14.5547 9.08594 14.1641L6.58594 11.6641C6.19531 11.3125 6.19531 10.7266 6.58594 10.375C6.9375 9.98438 7.52344 9.98438 7.91406 10.375L9.75 12.2109L14.0859 7.875C14.4375 7.48438 15.0234 7.48438 15.4141 7.875C15.7656 8.22656 15.7656 8.8125 15.4141 9.16406Z" fill="currentColor"></path>
    </svg>
  `;

  const arrowSvg = `
    <svg viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6.53 5.97c.31.31.31.78 0 1.06l-5 5c-.28.31-.75.31-1.03 0c-.31-.28-.31-.75 0-1.03l4.47-4.47L.47 2.03C.19 1.75.19 1.28.47 1c.31-.31.78-.31 1.06 0l5 4.97Z" fill="currentColor"></path>
    </svg>
  `;

  function hydrateSections(source) {
    return (source || []).map(function (section) {
      return {
        title: section.title || "",
        id: section.id || slug(section.title || "section"),
        badge: section.badge || "",
        groups: (section.groups || []).map(function (group) {
          return {
            title: group.title || "",
            groupEl: null,
            itemRefs: (group.itemRefs || []).map(function (item) {
              return {
                title: item.title || "",
                rowEl: null
              };
            })
          };
        }),
        navBtn: null,
        sectionEl: null
      };
    });
  }

  function flattenContent(source) {
    const flat = {};
    Object.keys(source || {}).forEach(function (sectionTitle) {
      const groups = source[sectionTitle] || {};
      Object.keys(groups).forEach(function (groupTitle) {
        const items = groups[groupTitle] || {};
        Object.keys(items).forEach(function (itemTitle) {
          flat[[sectionTitle, groupTitle, itemTitle].join("||")] = items[itemTitle] || {};
        });
      });
    });
    return flat;
  }

  function cleanText(value) {
    return String(value || "").replace(/[–—]/g, " ").replace(/\s+/g, " ").trim();
  }

  function normalizeSearch(value) {
    return cleanText(value).toLowerCase().replace(/[^a-z0-9\s]/g, " ").replace(/\s+/g, " ").trim();
  }

  function slug(value) {
    return normalizeSearch(value).replace(/\s+/g, "-") || "section";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function createBadgeHtml(text, withCheck) {
    const icon = withCheck ? '<span class="uhwwt__label-icon">' + checkSvg + '</span>' : "";
    return '<div class="uhwwt__panel-badge">' + icon + '<span>' + escapeHtml(text) + '</span></div>';
  }

  function createDetailItemHtml(label, value) {
    return '<li class="uhwwt__panel-detail-item"><span class="uhwwt__panel-detail-label">' + escapeHtml(label) + '</span><span class="uhwwt__panel-detail-value">' + escapeHtml(value) + '</span></li>';
  }

  function getDetails(section, group, item) {
    const key = [section.title, group.title, item.title].join("||");
    return detailsMap[key] || {};
  }

  function getFallbackCopy(sectionTitle, groupTitle, itemTitle) {
    const sectionFocus = meta[sectionTitle] ? meta[sectionTitle].focus : "male health, resilience, and personalised optimisation";
    return "Testing " + itemTitle + " helps ENGNE read biological signals linked with " + sectionFocus + ". It adds context for a more precise plan across training, nutrition, recovery, and long term performance.";
  }

  function getSectionItemCount(section) {
    return section.groups.reduce(function (total, group) {
      return total + group.itemRefs.length;
    }, 0);
  }

  function getSectionCountLabel(section, count) {
    const firstGroupTitle = section.groups[0] ? section.groups[0].title : "";
    const isEpigenetic = /epigenetic/i.test(firstGroupTitle) || /epigenetic/i.test(section.badge || "");
    if (isEpigenetic) {
      return count + (count === 1 ? " repeatable epigenetic test" : " repeatable epigenetic tests");
    }
    return count + (count === 1 ? " included DNA test" : " included DNA tests");
  }

  function getSectionFocus(section) {
    const value = meta[section.title] && meta[section.title].focus ? String(meta[section.title].focus).trim() : "male health, resilience, and personalised optimisation";
    return /[.!?]$/.test(value) ? value : value + ".";
  }

  function releaseNavigationLock(targetId) {
    if (navigationTargetId !== targetId) return;
    navigationTargetId = "";
    if (navigationReleaseTimer) {
      window.clearTimeout(navigationReleaseTimer);
      navigationReleaseTimer = 0;
    }
    setActiveNav(targetId);
  }

  function scrollToArea(section) {
    if (!section || !section.sectionEl) return;

    const targetId = section.id;
    navigationTargetId = targetId;

    if (navigationReleaseTimer) {
      window.clearTimeout(navigationReleaseTimer);
    }

    setActiveNav(targetId);
    section.sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });

    const release = function () {
      releaseNavigationLock(targetId);
    };

    if ("onscrollend" in window) {
      window.addEventListener("scrollend", release, { once: true });
    }

    navigationReleaseTimer = window.setTimeout(release, 1400);
  }

  function syncStickyOffset() {
    if (stickySyncFrame) window.cancelAnimationFrame(stickySyncFrame);

    stickySyncFrame = window.requestAnimationFrame(function () {
      stickySyncFrame = 0;

      const selector = "header, .header-wrapper, .shopify-section-group-header-group, [id*='shopify-section-header']";
      const candidates = Array.prototype.slice.call(document.querySelectorAll(selector));
      let headerBottom = 0;

      candidates.forEach(function (element) {
        if (!element || element.contains(root)) return;

        const style = window.getComputedStyle(element);
        if (style.display === "none" || style.visibility === "hidden") return;
        if (style.position !== "fixed" && style.position !== "sticky") return;

        const rect = element.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 24) return;

        headerBottom = Math.max(headerBottom, rect.bottom);
      });

      const stickyTop = Math.max(112, Math.ceil(headerBottom + 16));
      const rootDocumentTop = root.getBoundingClientRect().top + window.scrollY;
      const entryOffset = headerBottom > 0 ? Math.max(0, Math.ceil(headerBottom + 16 - rootDocumentTop)) : 0;

      root.style.setProperty("--uhwwt-sticky-top", stickyTop + "px");
      root.style.setProperty("--uhwwt-entry-offset", entryOffset + "px");
    });
  }

  function createCurrentAreaCard() {
    if (!leftEl || !sections.length) return;

    currentAreaEl = document.createElement("section");
    currentAreaEl.className = "uhwwt__current-card";
    currentAreaEl.setAttribute("aria-live", "polite");
    currentAreaEl.innerHTML = `
      <div class="uhwwt__current-topline">
        <p class="uhwwt__current-eyebrow">Current area</p>
        <p class="uhwwt__current-index" data-current-index></p>
      </div>
      <div class="uhwwt__current-progress" aria-hidden="true">
        <span class="uhwwt__current-progress-bar" data-current-progress></span>
      </div>
      <div class="uhwwt__current-body">
        <div class="uhwwt__current-heading">
          <h3 class="uhwwt__current-title" data-current-title></h3>
          <p class="uhwwt__current-count" data-current-count></p>
        </div>
        <div class="uhwwt__current-facts">
          <div class="uhwwt__current-fact">
            <span class="uhwwt__current-fact-label">Biological focus</span>
            <p class="uhwwt__current-focus" data-current-focus></p>
          </div>
        </div>
      </div>
      <div class="uhwwt__current-actions">
        <button type="button" class="uhwwt__current-action">
          <span>View area details</span>
          <span class="uhwwt__current-action-icon">${arrowSvg}</span>
        </button>
      </div>
    `;

    currentAreaEl.querySelector(".uhwwt__current-action").addEventListener("click", function () {
      if (currentAreaSection) buildAboutPanel(currentAreaSection);
    });

    (currentSlotEl || leftEl).appendChild(currentAreaEl);
    updateCurrentAreaCard(currentAreaSection.id);
  }

  function updateCurrentAreaCard(id) {
    if (!currentAreaEl) return;

    const section = sections.find(function (item) {
      return item.id === id;
    });

    if (!section) return;

    currentAreaSection = section;
    const index = sections.indexOf(section);
    const position = index + 1;
    const total = sections.length;
    const count = getSectionItemCount(section);
    const indexEl = currentAreaEl.querySelector("[data-current-index]");
    const progressEl = currentAreaEl.querySelector("[data-current-progress]");
    const titleEl = currentAreaEl.querySelector("[data-current-title]");
    const countEl = currentAreaEl.querySelector("[data-current-count]");
    const focusEl = currentAreaEl.querySelector("[data-current-focus]");

    if (indexEl) indexEl.textContent = String(position).padStart(2, "0") + " / " + String(total).padStart(2, "0");
    if (progressEl) progressEl.style.width = (position / total) * 100 + "%";
    if (titleEl) titleEl.textContent = section.title;
    if (countEl) countEl.textContent = getSectionCountLabel(section, count);
    if (focusEl) focusEl.textContent = getSectionFocus(section);
    currentAreaEl.hidden = false;
  }

  function openPanel(config) {
    if (!panelEl) return;

    const listItems = config.list || [];
    const showList = !!((config.listHtml && config.listHtml.length) || listItems.length);
    const showSubtitle = !!(config.subtitle && String(config.subtitle).trim());

    if (panelEyebrowEl) panelEyebrowEl.textContent = config.eyebrow || uiLabels.testDetails;
    if (panelTitleEl) panelTitleEl.textContent = config.title || "";

    if (panelSubtitleEl) {
      panelSubtitleEl.textContent = showSubtitle ? config.subtitle : "";
      panelSubtitleEl.hidden = !showSubtitle;
    }

    if (panelBadgesEl) panelBadgesEl.innerHTML = (config.badges || []).join("");
    if (panelMetaEl) {
      panelMetaEl.innerHTML = config.meta || "";
      panelMetaEl.hidden = !config.meta;
    }
    if (panelCopyEl) panelCopyEl.textContent = config.copy || "";

    if (panelListTitleEl) panelListTitleEl.textContent = config.listTitle || uiLabels.detailsListTitle;
    if (panelListEl) {
      panelListEl.innerHTML = config.listHtml || listItems.map(function (item) {
        return "<li>" + escapeHtml(item) + "</li>";
      }).join("");
    }

    if (panelBlockEl) {
      panelBlockEl.hidden = !showList;
    }

    panelEl.setAttribute("data-panel-mode", config.mode || "item");
    panelEl.setAttribute("data-list-mode", config.listMode || "default");
    panelEl.setAttribute("aria-hidden", "false");
    root.classList.add("is-panel-open");
    document.documentElement.style.overflow = "hidden";
  }

  function closePanel() {
    if (!panelEl) return;
    root.classList.remove("is-panel-open");
    panelEl.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function buildAboutPanel(section) {
    const itemList = [];
    section.groups.forEach(function (group) {
      group.itemRefs.forEach(function (item) {
        itemList.push(item.title);
      });
    });

    const sectionMeta = meta[section.title] || {};
    openPanel({
      mode: "about",
      eyebrow: uiLabels.areaTested,
      title: section.title,
      subtitle: sectionMeta.aboutTitle || "About this area",
      badges: [createBadgeHtml(section.badge || uiLabels.includedBadge, true)],
      meta: "",
      copy: sectionMeta.aboutText || "",
      listTitle: uiLabels.aboutListTitle,
      list: itemList,
      showList: true
    });
  }

  function buildItemPanel(section, group, item) {
    const custom = getDetails(section, group, item);
    const areaValue = custom.area || section.title;
    const groupValue = custom.group || group.title;
    const badgeText = custom.badge || section.badge || uiLabels.includedBadge;

    openPanel({
      mode: "item",
      eyebrow: uiLabels.testDetails,
      title: custom.title || item.title,
      subtitle: "",
      badges: [createBadgeHtml(badgeText, true)],
      meta: "",
      copy: custom.copy || getFallbackCopy(section.title, group.title, item.title),
      listTitle: uiLabels.detailsListTitle,
      listHtml: createDetailItemHtml(uiLabels.area, areaValue) + createDetailItemHtml(uiLabels.focusGroup, groupValue),
      listMode: "details",
      showList: true
    });
  }

  function render() {
    navEl.innerHTML = "";
    contentEl.innerHTML = "";

    sections.forEach(function (section, index) {
      const navBtn = document.createElement("button");
      navBtn.type = "button";
      navBtn.className = "uhwwt__nav-btn" + (index === 0 ? " is-active" : "");
      navBtn.textContent = section.title;
      navBtn.dataset.target = section.id;
      navBtn.addEventListener("click", function () {
        scrollToArea(section);
      });
      navEl.appendChild(navBtn);
      section.navBtn = navBtn;

      const sectionEl = document.createElement("section");
      sectionEl.className = "uhwwt__section";
      sectionEl.id = section.id;
      section.sectionEl = sectionEl;

      const sectionHead = document.createElement("div");
      sectionHead.className = "uhwwt__section-head";
      sectionHead.innerHTML = `
        <div class="uhwwt__section-title-wrap">
          <div class="uhwwt__section-icon">${iconSvg}</div>
          <h2 class="uhwwt__section-title">${escapeHtml(section.title)}</h2>
        </div>
        <button type="button" class="uhwwt__about-btn">About this area</button>
      `;

      sectionHead.querySelector(".uhwwt__about-btn").addEventListener("click", function () {
        buildAboutPanel(section);
      });

      const labels = document.createElement("div");
      labels.className = "uhwwt__labels";
      labels.innerHTML = `
        <div class="uhwwt__label">
          <span class="uhwwt__label-icon">${checkSvg}</span>
          <span>${escapeHtml(section.badge || uiLabels.includedBadge)}</span>
        </div>
      `;

      sectionEl.appendChild(sectionHead);
      sectionEl.appendChild(labels);

      section.groups.forEach(function (group) {
        const groupEl = document.createElement("div");
        groupEl.className = "uhwwt__group";
        group.groupEl = groupEl;

        const groupTitle = document.createElement("h3");
        groupTitle.className = "uhwwt__group-title";
        groupTitle.textContent = group.title;
        groupEl.appendChild(groupTitle);

        group.itemRefs.forEach(function (item) {
          const row = document.createElement("button");
          row.type = "button";
          row.className = "uhwwt__row";
          row.dataset.search = normalizeSearch(section.title + " " + group.title + " " + item.title);
          row.innerHTML = `
            <span class="uhwwt__row-left">
              <span class="uhwwt__row-check">${checkSvg}</span>
              <span class="uhwwt__row-title">${escapeHtml(item.title)}</span>
            </span>
            <span class="uhwwt__row-arrow">${arrowSvg}</span>
          `;
          row.addEventListener("click", function () {
            buildItemPanel(section, group, item);
          });

          item.rowEl = row;
          groupEl.appendChild(row);
        });

        sectionEl.appendChild(groupEl);
      });

      contentEl.appendChild(sectionEl);
    });
  }

  function setActiveNav(id) {
    sections.forEach(function (section) {
      if (!section.navBtn) return;
      section.navBtn.classList.toggle("is-active", section.id === id);
    });
    updateCurrentAreaCard(id);
  }

  function applySearch() {
    const query = normalizeSearch(searchInput.value);
    let matchCount = 0;
    let firstVisibleSectionId = null;

    clearBtn.classList.toggle("is-visible", !!query);

    sections.forEach(function (section) {
      let sectionVisible = false;

      section.groups.forEach(function (group) {
        let groupVisible = false;

        group.itemRefs.forEach(function (item) {
          const haystack = item.rowEl ? item.rowEl.dataset.search : "";
          const isMatch = !query || haystack.indexOf(query) > -1;
          if (item.rowEl) item.rowEl.hidden = !isMatch;

          if (isMatch) {
            groupVisible = true;
            sectionVisible = true;
            matchCount += 1;
          }
        });

        if (group.groupEl) group.groupEl.hidden = !groupVisible;
      });

      if (section.sectionEl) section.sectionEl.hidden = !sectionVisible;
      if (section.navBtn) section.navBtn.hidden = !sectionVisible;

      if (sectionVisible && !firstVisibleSectionId) {
        firstVisibleSectionId = section.id;
      }
    });

    if (noResultsEl) noResultsEl.hidden = matchCount !== 0;
    if (currentAreaEl) currentAreaEl.hidden = matchCount === 0;
    if (resultsEl) {
      resultsEl.textContent = query ? 'Showing ' + matchCount + ' results for "' + searchInput.value.trim() + '"' : "";
    }

    if (firstVisibleSectionId) setActiveNav(firstVisibleSectionId);
  }

  function scrollToFirstVisible() {
    const visibleSection = sections.find(function (section) {
      return section.sectionEl && !section.sectionEl.hidden;
    });

    if (visibleSection) {
      scrollToArea(visibleSection);
    }
  }

  function initObserver() {
    const observer = new IntersectionObserver(
      function (entries) {
        const visible = entries.filter(function (entry) {
          return entry.isIntersecting;
        }).sort(function (a, b) {
          return b.intersectionRatio - a.intersectionRatio;
        });

        if (navigationTargetId) return;

        if (visible.length) {
          setActiveNav(visible[0].target.id);
        }
      },
      {
        root: null,
        rootMargin: "-8% 0px -68% 0px",
        threshold: [0.1, 0.25, 0.4, 0.6]
      }
    );

    sections.forEach(function (section) {
      if (section.sectionEl) observer.observe(section.sectionEl);
    });
  }

  render();
  createCurrentAreaCard();
  applySearch();
  initObserver();
  syncStickyOffset();

  window.addEventListener("resize", syncStickyOffset, { passive: true });
  window.addEventListener("load", syncStickyOffset, { once: true });
  window.setTimeout(syncStickyOffset, 300);

  searchInput.addEventListener("input", applySearch);

  searchBtn.addEventListener("click", function () {
    if (!searchInput.value.trim()) {
      searchInput.focus();
      return;
    }
    applySearch();
    scrollToFirstVisible();
  });

  clearBtn.addEventListener("click", function () {
    searchInput.value = "";
    applySearch();
    searchInput.focus();
  });

  if (overlayEl) overlayEl.addEventListener("click", closePanel);
  if (panelCloseEl) panelCloseEl.addEventListener("click", closePanel);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closePanel();
  });
})();
